import { Link } from 'react-router-dom';

export default function PublicFooter() {
  return (
    <footer className="border-t border-border py-12 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-5 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#E04B2A' }}>
              <span className="text-[10px] font-extrabold text-white font-display">A</span>
            </div>
            <span className="font-display font-bold text-sm text-foreground">YuHasPro</span>
          </Link>
          <p className="text-[11px] text-muted-foreground leading-relaxed">The admissions operating system for Indian education.</p>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-3 font-bold">Product</p>
          <div className="space-y-2 text-[12px] text-muted-foreground">
            <Link to="/features/lead-management" className="block hover:text-foreground transition-colors">Lead Management</Link>
            <Link to="/features/admissions-pipeline" className="block hover:text-foreground transition-colors">Pipeline</Link>
            <Link to="/features/fee-collection" className="block hover:text-foreground transition-colors">Fee Collection</Link>
            <Link to="/features/analytics" className="block hover:text-foreground transition-colors">Analytics</Link>
          </div>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-3 font-bold">Platform</p>
          <div className="space-y-2 text-[12px] text-muted-foreground">
            <Link to="/features/multi-branch" className="block hover:text-foreground transition-colors">Multi-Branch</Link>
            <Link to="/features/communication" className="block hover:text-foreground transition-colors">Communication</Link>
            <Link to="/features/automation" className="block hover:text-foreground transition-colors">Automation</Link>
          </div>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-3 font-bold">Resources</p>
          <div className="space-y-2 text-[12px] text-muted-foreground">
            <Link to="/docs" className="block hover:text-foreground transition-colors">Documentation</Link>
            <Link to="/docs/getting-started/welcome" className="block hover:text-foreground transition-colors">Getting Started</Link>
            <Link to="/contact" className="block hover:text-foreground transition-colors">Contact Us</Link>
          </div>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-3 font-bold">Legal</p>
          <div className="space-y-2 text-[12px] text-muted-foreground">
            <Link to="/privacy" className="block hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="block hover:text-foreground transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-border flex items-center justify-between">
        <p className="text-[10px] text-muted-foreground font-mono">&copy; 2026 YuHasPro. All rights reserved.</p>
        <p className="text-[10px] text-muted-foreground font-mono">Made in India</p>
      </div>
    </footer>
  );
}
